angular.module('app').component('summarySelectedTrace', {
    bindings: {
        params: '<', // ISummarySelectedTraceParams
        onToggle: '&' // toggle auto refresh
    },
    // resolve: '^^parent',
    controllerAs: 'vm',
    controller: function (UtpSummaryServiceApi, $uibModal, SelectedTraceServiceApi, ViewMediaModalService) {
        let vm = this;
        // controller level variable
        let params;
        let traceId;
        let selectedTraceDto;
        // view model methods
        vm.viewXmlContent = viewXmlContent;
        vm.openDetails = openDetails;
        this.$onInit = function () {
            // Initialise
            vm.selectedTraceDto = {
                Tester: { Id: -1, Name: 'Not Selected' },
                Sim: { Id: -1, Name: 'Not Selected' },
                Suite: { Id: -1, Name: 'Not Selected' },
                Test: { Id: -1, Name: 'Not Selected', TruncatedNameNarrow: 'Not Selected' }
            };
            vm.bit41 = '';
            vm.bit42 = '';
        };
        this.$onChanges = function (changes) {
            if (!changes.params.currentValue) {
                // params = changes.params.currentValue;
                params = undefined;
                vm.detailsDisabled();
                vm.xmlDisabled();
                return;
            }
            // TODO - we make no use of any updated params here - doesnt look right
            params = this.params;
            // Changed traceId
            traceId = params.traceId;
            renderSelectedTraceDto(traceId);
            // Get the tester as we need him to open trace details
            // But why? Is it the connectedUser or could it be support
            // Why doesn't mtTraceDetails do this by itself?
        };
        function renderSelectedTraceDto(traceId) {
            vm.traceDetailsLoading = true;
            SelectedTraceServiceApi.details(traceId).then(function (response) {
                vm.traceDetailsLoading = false;
                if (response.data) {
                    vm.selectedTraceDto = {
                        Sim: response.data.Sim,
                        Suite: response.data.Suite,
                        Test: response.data.Test,
                        Tester: response.data.Tester,
                        ProjectIterationId: response.data.ProjectIterationId,
                        ProtocolFields: response.data.ProtocolFields
                    };
                }
                vm.bit41 = vm.selectedTraceDto.ProtocolFields && vm.selectedTraceDto.ProtocolFields['Bit41'];
                vm.bit42 = vm.selectedTraceDto.ProtocolFields && vm.selectedTraceDto.ProtocolFields['Bit42'];
            });
        }
        // Manage button states
        vm.detailsDisabled = function () {
            return angular.isUndefined(params) || (!angular.isUndefined(selectedTraceDto) && !angular.isUndefined(selectedTraceDto.Tester) && selectedTraceDto.Tester.Id === 0);
        };
        vm.xmlDisabled = function () {
            return angular.isUndefined(params);
        };
        function viewXmlContent() {
            UtpSummaryServiceApi.getTraceXmlContent(traceId, true).then(function (response) {
                let xml = response.data;
                viewXml(xml, traceId);
            });
        }
        function openDetails() {
            // TODO: Rework trace details so that it will accept a traceId
            // TODO: Figure out which TraceDetails we are using
            // Should be MtTraceDetails
            let selectedItemsModel = {
                selectedTester: vm.selectedTraceDto.Tester,
                selectedSim: vm.selectedTraceDto.Sim,
                selectedSuite: vm.selectedTraceDto.Suite,
                selectedTest: vm.selectedTraceDto.Test,
                projectIterationId: vm.selectedTraceDto.ProjectIterationId,
                selectedTraceId: this.traceId
            };
            let tdParams = {
                selectedItems: selectedItemsModel,
                mode: params.mode,
                user: params.user,
                overTheShoulder: params.overTheShoulder
            };
            let modalInstance = $uibModal.open({
                animation: true,
                size: 'xl',
                backdrop: 'static',
                component: 'traceDetailsModal',
                resolve: {
                    params: function () {
                        return tdParams;
                    }
                }
            });
            modalInstance.result.then(
            // close callback
            function () {
            }, 
            // cancel callback
            function () {
            });
        }
        function viewXml(xml, traceId) {
            // Package up our xml as a media object
            let media = {
                Content: xml,
                ContentSubType: 'text',
                FileName: '', // Empty file name supresses title display
                Timestamp: '',
                UserName: '',
                TraceUid: traceId
            };
            ViewMediaModalService.open(media);
        }
    },
    template: `
<!-- Selected Trace details -->
<div class="col-md-4" sticky offset-top="150">
    <div class="panel panel-primary my-child box-shadow--4dp">
        <div class="panel-heading">
            <span class="panel-title">Selected Trace Details</span>
        </div>
        <div class="panel-body" ng-class="{'text-muted': vm.selectedItems.selectedSim.Id == 0}">
            <div class="text-center" ng-show="vm.traceDetailsLoading">
                <i class="fa fa-spinner fa-spin fa-3x fa-fw margin-bottom text-muted"></i>
                <span class="sr-only">Loading...</span>
            </div>
            <div ng-show="!vm.traceDetailsLoading">
                <div class="fade-in-out">
                    <i class="glyphicon glyphicon-user space-right"></i>&nbsp;{{vm.selectedTraceDto.Tester.Name}}
                </div>
                <div>
                    <i class="glyphicon glyphicon-transfer space-right"></i>&nbsp;{{vm.selectedTraceDto.Sim.Name}}
                </div>
                <div>
                    <i class="glyphicon glyphicon-tags space-right"></i>&nbsp;{{vm.selectedTraceDto.Suite.Name}}
                </div>
                <div
                popover-append-to-body="true"
                popover-placement="auto"
                popover-trigger="'mouseenter'"
                uib-popover-template="'summary-selected-trace-test-name.html'">
                    <i class="glyphicon glyphicon-flash space-right"></i>&nbsp;{{vm.selectedTraceDto.Test.TruncatedNameNarrow}}
                </div>
                <!-- New Bit 41 and Bit42 Attributes, shown only when available -->
                <div ng-if="vm.bit41">
                    <i class="fa fa-terminal space-right"></i> Bit 41:&nbsp;{{vm.bit41}}
                </div>
                <div ng-if="vm.bit42">
                    <i class="fa fa-terminal space-right"></i> Bit 42:&nbsp;{{vm.bit42}}
                </div>

                <div class="pull-right space-top">
                    <!-- Details Button -->
                    <button class="btn btn-info btn-xs text-mono space-left space-right"
                        ng-disabled="vm.detailsDisabled()" ng-click="vm.openDetails()"
                        uib-dropdown-toggle popover-trigger="'mouseenter'"
                        uib-popover="Select trace first to view details" popover-animation
                        popover-placement="bottom" popover-append-to-body="true">
                        View Test Traces...
                    </button>

                    <!-- View XML button -->
                    <button class="btn btn-info btn-xs text-mono space-left space-right"
                        ng-disabled="vm.xmlDisabled()" ng-click="vm.viewXmlContent()"
                        uib-dropdown-toggle popover-trigger="'mouseenter'"
                        uib-popover="Select trace first to view Xml" popover-animation
                        popover-placement="bottom" popover-append-to-body="true">
                        View Xml
                        <i class="fa fa-file-text-o space-left space-right"></i>
                    </button>
                </div>
            </div>
        </div>
    </div>
</div>

<script type="text/ng-template" id="summary-selected-trace-test-name.html">
    <span class="popover-white-space-wrap">{{vm.selectedTraceDto.Test.Name}}</span>
</script>

`
});
